import React from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface OcConfirmationDialogProps {
  showDialog: boolean;
  onClose: () => void;
  onCancel: () => void;
  title: string;
  texts?: string[];
  okButtonText: string;
  cancelButtonText: string;
}

export const OcConfirmationDialog: React.FC<OcConfirmationDialogProps> = ({
  showDialog,
  onClose,
  onCancel,
  title,
  texts = [],
  okButtonText,
  cancelButtonText,
}) => {
  const isMobile = useOcIsMobile();

  return (
    <Dialog aria-labelledby="confirm-dialog" open={showDialog}>
      <Box
        id="my-cafeteria-confirmation-dialog"
        width={isMobile ? "auto" : "432px"}
        minHeight={isMobile ? "auto" : "239px"}
        padding="24px"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Typography
          variant="h6"
          style={{ textAlign: isMobile ? "center" : "unset" }}
        >
          {title}
        </Typography>
        <Box height="36px" />
        {texts?.map((text, index) => (
          <Box key={index}>
            {index === 1 && <Box height="32px" />}
            <Typography>{text}</Typography>
          </Box>
        ))}
        <Box height="36px" />
        <Button
          id="oc-confirmation-dialog-ok-button"
          onClick={onClose}
          fullWidth
          variant="contained"
          color="primary"
          disableElevation
          style={{ padding: "9px 0px" }}
        >
          {okButtonText}
        </Button>
        <Box height="36px" />
        <Button
          id="oc-confirmation-dialog-cancel-button"
          onClick={onCancel}
          fullWidth
          variant="text"
          color="secondary"
          style={{ padding: "9px 0px" }}
        >
          {cancelButtonText}
        </Button>
      </Box>
    </Dialog>
  );
};

export default OcConfirmationDialog;
